<template>
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.00004 15.1666C11.6819 15.1666 14.6667 12.1818 14.6667 8.49992C14.6667 4.81802 11.6819 1.83325 8.00004 1.83325C4.31814 1.83325 1.33337 4.81802 1.33337 8.49992C1.33337 12.1818 4.31814 15.1666 8.00004 15.1666Z"
      stroke="#4C4C60"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M1.33337 8.5H14.6667"
      stroke="#4C4C60"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.00004 1.83325C9.66756 3.65882 10.6152 6.02794 10.6667 8.49992C10.6152 10.9719 9.66756 13.341 8.00004 15.1666C6.33252 13.341 5.38487 10.9719 5.33337 8.49992C5.38487 6.02794 6.33252 3.65882 8.00004 1.83325V1.83325Z"
      stroke="#4C4C60"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
